import { render } from "./BoxPlanGlide.vue?vue&type=template&id=5722ec09&scoped=true"
import script from "./BoxPlanGlide.vue?vue&type=script&lang=js"
export * from "./BoxPlanGlide.vue?vue&type=script&lang=js"

import "./BoxPlanGlide.vue?vue&type=style&index=0&id=5722ec09&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5722ec09"]])

export default __exports__